@import 'styles/mixins';
@import 'styles/blaze/mixins';

.moreButton {
  position: relative;
  @include transition;
  display: inline;
  color: var(--dark-40);
  padding-left: 5px;
  z-index: 2;

  &.expandable {
    cursor: pointer;

    &:hover {
      color: var(--selected-fill);
    }
  }

  &.less {
    display: inline-flex;
    width: 100%;
    justify-content: flex-end;
  }
}

.caption {
  word-break: break-all;
  white-space: break-spaces;
  display: inline;
  pointer-events: none;
  opacity: 1 !important;

  &.defaultTruncation {
    @include line-clamp(2);
  }

  div,
  p {
    word-break: break-all;
    color: var(--dark-80);
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16.44px;
    letter-spacing: normal;
    margin: 0;
  }
}
